import { render, staticRenderFns } from "./Requisites.vue?vue&type=template&id=55d6c902&lang=pug"
import script from "./Requisites.vue?vue&type=script&lang=js"
export * from "./Requisites.vue?vue&type=script&lang=js"
import style0 from "./Requisites.vue?vue&type=style&index=0&id=55d6c902&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports